<template>
	<div><span class="biaoti">支付记录</span>
	<el-tabs type="border-card">
		<el-tab-pane label="支付记录">			
				<el-collapse>
					<el-collapse-item title="筛选">
						<el-form ref="form" :model="so" width="80" style="margin-left: 80px;">
							<el-form-item label="订单号" placeholder="订单号">
								<el-input v-model="so.dingdanhao"></el-input>
							</el-form-item>
							<el-form-item label="会员昵称">
								<el-input v-model="so.guanjianci"></el-input>
							</el-form-item>
							<el-form-item label="下单时间">						
								<el-col :span="4">
									<el-date-picker type="date" placeholder="选择日期" v-model="so.kaishi" style="width: 95%;"></el-date-picker>
								</el-col>
								<el-col class="line" :span="1">至</el-col>
								<el-col :span="4">
									<el-date-picker type="date" placeholder="选择日期" v-model="so.jieshu" style="width: 100%; margin-left: -1.8125rem;"></el-date-picker>
								</el-col>
							</el-form-item>
							<el-button size="mini" type="info" style="margin-left: 80px;">搜索</el-button>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			
			<el-table :data="shu">
				<el-table-column prop="shijian" label="支付时间" width="200">
				</el-table-column>
				<el-table-column prop="dingdanhao" label="订单号" width="200"/>
				<el-table-column prop="jine" label="金额" width="200">
					<template slot-scope="shu">
					    <el-tag effect="dark">{{shu.row.jin_e}}</el-tag>
					 </template>
				</el-table-column>
				<el-table-column prop="hyid" label="会员ID" width="100"/>
				<el-table-column label="会员" >
					 <template slot-scope="shu">
						<el-avatar shape="square" :src="shu.row.touxiang"></el-avatar>
						<span style="position:absolute; top:1.25rem; left: 3.75rem;color: #428bca;">{{shu.row.nicheng}}</span>
					 </template>
				</el-table-column>
				<el-table-column prop="_leixing" label="支付信息" />				
			</el-table>
	       <el-pagination layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="jitiao"  :current-page.sync="ye" @current-change="Fenye" style="margin-top: 30px;"/>
	    
		</el-tab-pane>
	</el-tabs>
</div>
</template>

<script>
	let that;
	export default {		
		data() {
			return {
				so: {},
				ye:1,
				jitiao:20,
				shu:[],
				zongshu:0,					  
			};
		},
		created() {
			that=this;
			that.CSH();
		},
		methods: {
			CSH(){
				that.so.ye=that.ye;
				that.so.jitiao=that.jitiao;
				this.$post('k=zhifujilu',that.so,function(s){
					that.shu=s.shu.lie;
					that.zongshu=Number(s.shu.zongshu);
				}); 
			},
			Fenye(e){
				that.ye=e;
				that.CSH();				
			}
		}
	}
</script>
<style scope>
	.annui {
		display: flex;
		justify-content: flex-start;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}
	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}
</style>
